import React, { FC } from "react";
import { Form, Input } from "antd";
import { Col, Row } from "antd";
import { DatePicker } from "antd";

type PatientDetailsProps = {
  form: any;
};

const PatientDetails: FC<PatientDetailsProps> = ({
  form,
}) => {
  const dateFormat = "DD-MM-YYYY HH:mm:ss";
  return (
    <div>
      {/* <div
        style={{
          textDecoration: "underline",
          fontSize: "16px",
          margin: "16px 0",
          fontWeight: "bold",
        }}
      >
        PATIENT DETAILS
      </div> */}

      <Form
        form={form}
        labelAlign="left"
        layout="vertical"
        labelWrap
        style={{ width: "100%", }}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item label="PATIENT NAME" name="fullName">
              <Input disabled={true} style={{color: "black"}} placeholder="Enter patient Name" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item label="AGE" name="age">
              <Input disabled={true} style={{color: "black"}} placeholder="Enter age" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item label="ADDRESS" name="address">
              <Input disabled={true} style={{color: "black"}} placeholder="Enter address" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item label="PHONE NUMBER" name="primaryMobile">
              <Input disabled={true} style={{color: "black"}} placeholder="Enter phone Number" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item label="Referral Type" name="referralType">
              <Input disabled={true} style={{color: "black"}} placeholder="Enter referral Type" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item label="PATIENT TYPE" name="patientType">
              <Input disabled={true} style={{color: "black"}} placeholder="Enter patient Type" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item label="REGION" name="region">
              <Input disabled={true} style={{color: "black"}} placeholder="Enter region" />
            </Form.Item>
          </Col>

          {/* <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              label="FINANCIAL YEAR"
              name="financialYear"
            >
              <Input disabled={true} style={{color: "black"}} 
              placeholder="Enter financialYear" />
            </Form.Item>
          </Col> */}

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item label="Name Of ESM" name="nameOfESM">
              <Input disabled={true} style={{color: "black"}} placeholder="Enter name Of ESM" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item label="Card TYPE" name="cardType">
              <Input disabled={true} style={{color: "black"}} placeholder="Enter card Type" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item label="Category" name="category">
              <Input disabled={true} style={{color: "black"}} placeholder="Enter category" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item label="WHITE CARD APPLICABLE" name="whitwCardApplicable">
              <Input disabled={true} style={{color: "black"}} placeholder="Enter white Card Applicable" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item label="RANK" name="rank">
              <Input disabled={true} style={{color: "black"}} placeholder="Enter rank" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item label="GENDER" name="gender">
              <Input disabled={true} style={{color: "black"}} placeholder="Enter gender" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              label="RELATION WITH CARD HOLDER"
              name="relationWithCardHolder"
            >
              <Input
                disabled={true} style={{color: "black"}}
                placeholder="Enter relation With Card Holder "
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              label="PATIENT'S AADHAR/UID CARD STATUS"
              name="patientUIDCardStatus"
            >
              <Input
                disabled={true} style={{color: "black"}}
                placeholder="Enter patient'sAadhar/UIDCardStatus "
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              label="PATIENT'S AADHAR/UID NUMBER"
              name="patientUIDNumber"
            >
              <Input
                disabled={true} style={{color: "black"}}
                placeholder="Enter patient'sAadhar/UIDNumber "
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item label="CITY" name="city">
              <Input disabled={true} style={{color: "black"}} placeholder="Enter city " />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item label="STATE" name="state">
              <Input disabled={true} style={{color: "black"}} placeholder="Enter state " />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item label="PINCODE" name="pincode">
              <Input disabled={true} style={{color: "black"}} placeholder="Enter pincode" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item label="EMAIL" name="email">
              <Input disabled={true} style={{color: "black"}} placeholder="Enter email " />
            </Form.Item>
          </Col>

          {/* <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              label="PHONE"
              name="phoneNumber"
            >
              <Input disabled={true} style={{color: "black"}} 
              placeholder="Enter phoneNumber " />
            </Form.Item>
          </Col> */}
        </Row>
      </Form>
    </div>
  );
};

export default PatientDetails;
 